// TrajeRentalSystem.js
import React from 'react';
import { useTrajeRental } from './hooks/useTrajeRental';
import TrajeRentalSystemView from './TrajeRentalSystemView';

const TrajeRentalSystem = () => {
  const hookData = useTrajeRental();

  // Opción 1: Explícita (recomendada para claridad)
  const {
    // Estados que usa el view
    trajes,
    categorias,
    filtroCategoria,
    modalTallas,
    loading,
    error,
    isOnline,
    cachedImages,
    
    // Funciones que usa el view
    setFiltroCategoria,
    setModalTallas,
    cargarTrajes,
    mostrarTallas,
    enviarWhatsApp,
    formatLastUpdate,
    getImageUrl,
    handleImageError,
    handleImageLoad,
    
    // lastUpdate no se pasa porque no se usa directamente en el view
    // Se accede a través de formatLastUpdate()
  } = hookData;

  return (
    <TrajeRentalSystemView
      trajes={trajes}
      categorias={categorias}
      filtroCategoria={filtroCategoria}
      modalTallas={modalTallas}
      loading={loading}
      error={error}
      isOnline={isOnline}
      cachedImages={cachedImages}
      setFiltroCategoria={setFiltroCategoria}
      setModalTallas={setModalTallas}
      cargarTrajes={cargarTrajes}
      mostrarTallas={mostrarTallas}
      enviarWhatsApp={enviarWhatsApp}
      formatLastUpdate={formatLastUpdate}
      getImageUrl={getImageUrl}
      handleImageError={handleImageError}
      handleImageLoad={handleImageLoad}
    />
  );
};

// Opción 2: Usando spread operator (más concisa)
// const TrajeRentalSystem = () => {
//   const { lastUpdate, ...viewProps } = useTrajeRental();
//   return <TrajeRentalSystemView {...viewProps} />;
// };

export default TrajeRentalSystem;